import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import Login from '../components/auth/Login';
import ForgetPassword from '../components/auth/ForgetPassword';
import ConfirmMail from '../components/auth/ConfirmMail';
import PasswordReset from '../components/auth/PasswordReset';
import ConfirmEmail from '../components/auth/ConfirmEmail';
import ConfirmEmailSuccess from '../components/auth/ConfirmEmailSuccess';

const AuthRoutes = ({ match: { url } }) =>
  <Switch>
    <Route path={`${url}/login`} exact component={Login} />
    <Route path={`${url}/forget-password`} exact component={ForgetPassword} />
    <Route path={`${url}/validate-mail`} exact component={ConfirmEmail} />
    <Route path={`${url}/validate-success`} exact component={ConfirmEmailSuccess} />
    <Route path={`${url}/confirm-mail`} exact component={ConfirmMail} />
    <Route path={`${url}/password-reset`} exact component={PasswordReset} />
    <Redirect to="/errors/404" />
  </Switch>

AuthRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(AuthRoutes);